const ErrorText = ({children}) => <p className='text-red-500 text-xs bg-white error-message'>{children}</p>;

export default ErrorText;
